<template>
  <div v-if="visible" class="maintenance-wrap">
    <div class="maintenance-card">
      <h1 class="maintenance-title">{{ t('maintenance.title') }}</h1>
      <p class="maintenance-desc">
        {{ t('maintenance.desc') }}<br>
        {{ t('maintenance.desc2') }}
      </p>
      <div class="maintenance-time">
        <div class="loading-dot">
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { watch, onMounted, onUnmounted } from 'vue';
import { useI18n } from 'vue-i18n';

const { t } = useI18n();

const props = defineProps({
  visible: {
    type: Boolean,
    default: false
  }
});

watch(() => props.visible, (newVal) => {
  console.log('visible变化:', newVal)
  if (newVal) {
    document.body.style.overflow = 'hidden';
  } else {
    document.body.style.overflow = '';
  }
});

onMounted(() => {
  if (props.visible) {
    document.body.style.overflow = 'hidden';
  }
});

onUnmounted(() => {
  document.body.style.overflow = '';
});
</script>

<style scoped lang="scss">
.maintenance-wrap {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  padding: 20px;
  z-index: 9999;
  overflow: hidden;
}

.maintenance-wrap::before,
.maintenance-wrap::after {
  content: "";
  position: absolute;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.3);
  z-index: 0;
}

.maintenance-wrap::before {
  width: 300px;
  height: 300px;
  top: -100px;
  right: -100px;
}

.maintenance-wrap::after {
  width: 200px;
  height: 200px;
  bottom: -80px;
  left: -80px;
}

.maintenance-card {
  background: rgba(255, 255, 255, 0.95);
  padding: 60px 80px;
  border-radius: 20px;
  box-shadow: 0 15px 35px rgba(0, 0, 0, 0.1);
  position: relative;
  z-index: 1;
  transition: transform 0.3s ease;
}

.maintenance-card:hover {
  transform: translateY(-5px);
}

.maintenance-title {
  font-size: 48px;
  color: #2c3e50;
  margin-bottom: 20px;
  font-weight: 700;
  background: linear-gradient(90deg, #3498db, #9b59b6);
  -webkit-background-clip: text;
  color: transparent;
}

.maintenance-desc {
  font-size: 18px;
  color: #7f8c8d;
  line-height: 1.8;
  margin-bottom: 30px;
  max-width: 600px;
}

.maintenance-time {
  font-size: 16px;
  color: #34495e;
  padding: 12px 30px;
  background: #f8f9fa;
  border-radius: 30px;
  display: inline-block;
  border: 1px solid #e6e6e6;
}

.loading-dot {
  display: inline-block;
  margin-left: 8px;
}

.loading-dot span {
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #3498db;
  margin: 0 2px;
  animation: bounce 1.4s infinite ease-in-out both;
}

.loading-dot span:nth-child(1) {
  animation-delay: -0.32s;
}

.loading-dot span:nth-child(2) {
  animation-delay: -0.16s;
}

@keyframes bounce {

  0%,
  80%,
  100% {
    transform: scale(0);
  }

  40% {
    transform: scale(1);
  }
}
</style>
